import { supabase } from "@/infrastructure/supabase/client";
import type { ProductScoreRow, ScoreValue } from "@/infrastructure/supabase/database.types";

export interface UpsertProductScoreInput {
  product_id: string;
  criterion_id: string;
  score: ScoreValue | null;
  dealbreaker_fail: boolean;
  evidence_md: string | null;
  vibes_revisit: boolean;
}

export const productScoresRepository = {
  async list(): Promise<ProductScoreRow[]> {
    const { data, error } = await supabase.from("product_scores").select("*");
    if (error) throw error;
    return data ?? [];
  },

  async listByProduct(productId: string): Promise<ProductScoreRow[]> {
    const { data, error } = await supabase
      .from("product_scores")
      .select("*")
      .eq("product_id", productId);
    if (error) throw error;
    return data ?? [];
  },

  async upsert(input: UpsertProductScoreInput): Promise<ProductScoreRow> {
    const { data, error } = await supabase
      .from("product_scores")
      .upsert(input, { onConflict: "product_id,criterion_id" })
      .select("*")
      .single();
    if (error) throw error;
    return data;
  },
};
